import { gql } from "@apollo/client";

export const GET_CONTRATO_CONDICIONAL = gql`
  query contratoCondicionalByIdPaciente($idPaciente: Int!) {
    contratoCondicionalByIdPaciente(idPaciente: $idPaciente)
  }
`;